/**
 * 势力专属科技 - 每势力3项独有科技 (共21项)
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 */

import type { Tech } from '../TechTypes';

// 炎国 🔥 (攻击型)
const YAN_TECHS: Tech[] = [
  {
    id: 'F_YAN_1',
    name: '烈焰焚天',
    description: '火焰攻击：炎国单位附带灼烧伤害',
    branch: 'faction',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['B011'],
    factionExclusive: 'yan',
    effects: {
      bonuses: { attackBonus: 1.2 },
      special: { fireArrows: true },
    },
    position: { x: 15, y: 45 },
    nodeShape: 'octagon',
    icon: '🔥',
  },
  {
    id: 'F_YAN_2',
    name: '浴火重生',
    description: '玉石俱焚：炎国单位死亡时爆炸伤害敌人',
    branch: 'faction',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['F_YAN_1'],
    factionExclusive: 'yan',
    effects: {
      bonuses: { attackBonus: 1.25, morale: 1.2 },
    },
    position: { x: 15, y: 65 },
    nodeShape: 'octagon',
    icon: '🦅',
  },
  {
    id: 'F_YAN_3',
    name: '炎帝之怒',
    description: '势力终极：解锁炎帝化身，究极火焰单位',
    branch: 'faction',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['F_YAN_2', 'Y021'],
    factionExclusive: 'yan',
    effects: {
      bonuses: { attackBonus: 1.4, siegeBonus: 1.5 },
      special: { fireArrows: true },
    },
    position: { x: 15, y: 85 },
    nodeShape: 'octagon',
    icon: '👑',
    quote: '炎帝临世，万物焚尽',
  },
];

// 寒国 ❄️ (防御型)
const HAN_TECHS: Tech[] = [
  {
    id: 'F_HAN_1',
    name: '寒冰护甲',
    description: '寒冰反制：寒国单位被攻击时冻结敌人',
    branch: 'faction',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['B015'],
    factionExclusive: 'han',
    effects: {
      bonuses: { defenseBonus: 1.2, shieldDefense: 1.15 },
    },
    position: { x: 30, y: 45 },
    nodeShape: 'octagon',
    icon: '🛡️',
  },
  {
    id: 'F_HAN_2',
    name: '永冻之心',
    description: '极寒之城：寒国城池免疫火焰伤害',
    branch: 'faction',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['F_HAN_1'],
    factionExclusive: 'han',
    effects: {
      bonuses: { defenseBonus: 1.3, repairSpeed: 1.4 },
    },
    position: { x: 30, y: 65 },
    nodeShape: 'octagon',
    icon: '💎',
  },
  {
    id: 'F_HAN_3',
    name: '玄冰绝对',
    description: '势力终极：解锁冰晶巨人，究极寒冰单位',
    branch: 'faction',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['F_HAN_2', 'Y013'],
    factionExclusive: 'han',
    effects: {
      bonuses: { defenseBonus: 1.5, shieldDefense: 1.4, shieldBlock: 1.3 },
    },
    position: { x: 30, y: 85 },
    nodeShape: 'octagon',
    icon: '❄️',
    quote: '玄冰封天，万物寂灭',
  },
];

// 林国 🌲 (伏击型)
const LIN_TECHS: Tech[] = [
  {
    id: 'F_LIN_1',
    name: '丛林潜行',
    description: '自然伪装：林国单位在森林隐身',
    branch: 'faction',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['Y002'],
    factionExclusive: 'lin',
    effects: {
      bonuses: { forestBonus: 1.35, speedBonus: 1.15 },
      special: { ambush: true },
    },
    position: { x: 45, y: 45 },
    nodeShape: 'octagon',
    icon: '🌿',
  },
  {
    id: 'F_LIN_2',
    name: '万箭齐发',
    description: '箭雨覆盖：林国弓兵可齐射，范围伤害',
    branch: 'faction',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['F_LIN_1', 'B013'],
    factionExclusive: 'lin',
    effects: {
      bonuses: { archerAttack: 1.35, archerRange: 1.2 },
    },
    position: { x: 45, y: 65 },
    nodeShape: 'octagon',
    icon: '🏹',
  },
  {
    id: 'F_LIN_3',
    name: '森罗万象',
    description: '势力终极：解锁树人守卫，究极森林单位',
    branch: 'faction',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['F_LIN_2', 'Y012'],
    factionExclusive: 'lin',
    effects: {
      bonuses: { forestBonus: 1.5, unitHealthBonus: 1.3, taoistHeal: 1.3 },
      special: { healingAura: true },
    },
    position: { x: 45, y: 85 },
    nodeShape: 'octagon',
    icon: '🌳',
    quote: '森罗万象，自然之力',
  },
];

// 商国 💰 (经济型)
const SHANG_TECHS: Tech[] = [
  {
    id: 'F_SHANG_1',
    name: '招财进宝',
    description: '战争获利：商国击杀敌人获得金币',
    branch: 'faction',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['S015'],
    factionExclusive: 'shang',
    effects: {
      bonuses: { incomeBonus: 1.25 },
    },
    position: { x: 60, y: 45 },
    nodeShape: 'octagon',
    icon: '🧧',
  },
  {
    id: 'F_SHANG_2',
    name: '金钱万能',
    description: '收买敌军：可用金币直接购买敌方单位',
    branch: 'faction',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['F_SHANG_1'],
    factionExclusive: 'shang',
    effects: {
      bonuses: { incomeBonus: 1.35, goldCapacity: 1.5 },
    },
    position: { x: 60, y: 65 },
    nodeShape: 'octagon',
    icon: '💵',
  },
  {
    id: 'F_SHANG_3',
    name: '富甲天下',
    description: '势力终极：金币转化为全属性加成',
    branch: 'faction',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['F_SHANG_2', 'S031'],
    factionExclusive: 'shang',
    effects: {
      bonuses: { incomeBonus: 1.5, attackBonus: 1.2, defenseBonus: 1.2 },
    },
    position: { x: 60, y: 85 },
    nodeShape: 'octagon',
    icon: '🏆',
    quote: '富可敌国，金钱即力量',
  },
];

// 玄国 🔮 (法术型)
const XUAN_TECHS: Tech[] = [
  {
    id: 'F_XUAN_1',
    name: '道法自然',
    description: '道术增强：玄国道士单位伤害+30%',
    branch: 'faction',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['Y001'],
    factionExclusive: 'xuan',
    effects: {
      bonuses: { taoistPower: 1.3 },
    },
    position: { x: 75, y: 45 },
    nodeShape: 'octagon',
    icon: '☯️',
  },
  {
    id: 'F_XUAN_2',
    name: '符咒之术',
    description: '诅咒敌军：道士可施放减益符咒',
    branch: 'faction',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['F_XUAN_1'],
    factionExclusive: 'xuan',
    effects: {
      bonuses: { taoistPower: 1.35, morale: 1.2 },
    },
    position: { x: 75, y: 65 },
    nodeShape: 'octagon',
    icon: '📜',
  },
  {
    id: 'F_XUAN_3',
    name: '天师降临',
    description: '势力终极：解锁张天师，究极道法单位',
    branch: 'faction',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['F_XUAN_2', 'Y031'],
    factionExclusive: 'xuan',
    effects: {
      bonuses: { taoistPower: 1.6, taoistHeal: 1.5, morale: 1.3 },
    },
    position: { x: 75, y: 85 },
    nodeShape: 'octagon',
    icon: '🧙',
    quote: '天师临世，道法无边',
  },
];

// 铁国 🛡️ (重甲型)
const TIE_TECHS: Tech[] = [
  {
    id: 'F_TIE_1',
    name: '铁血军魂',
    description: '钢铁意志：铁国单位血量低于30%时防御翻倍',
    branch: 'faction',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['B003'],
    factionExclusive: 'tie',
    effects: {
      bonuses: { defenseBonus: 1.2, shieldDefense: 1.25 },
    },
    position: { x: 20, y: 45 },
    nodeShape: 'octagon',
    icon: '⚔️',
  },
  {
    id: 'F_TIE_2',
    name: '重甲冲锋',
    description: '铁甲洪流：铁国重甲单位冲锋伤害+50%',
    branch: 'faction',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['F_TIE_1', 'G012'],
    factionExclusive: 'tie',
    effects: {
      bonuses: { defenseBonus: 1.25, cavalryCharge: 1.5 },
    },
    position: { x: 20, y: 65 },
    nodeShape: 'octagon',
    icon: '🏃',
  },
  {
    id: 'F_TIE_3',
    name: '铁壁铜墙',
    description: '势力终极：解锁铁卫军团，究极重甲单位',
    branch: 'faction',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['F_TIE_2', 'G033'],
    factionExclusive: 'tie',
    effects: {
      bonuses: { defenseBonus: 1.5, shieldDefense: 1.5, shieldBlock: 1.4 },
      special: { shieldWall: true },
    },
    position: { x: 20, y: 85 },
    nodeShape: 'octagon',
    icon: '🏰',
    quote: '铁壁铜墙，固若金汤',
  },
];

// 云国 🌬️ (机动型)
const YUN_TECHS: Tech[] = [
  {
    id: 'F_YUN_1',
    name: '疾风骤雨',
    description: '冲锋加成：云国骑兵移动后首次攻击+30%',
    branch: 'faction',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['B012'],
    factionExclusive: 'yun',
    effects: {
      bonuses: { cavalryAttack: 1.3, speedBonus: 1.2 },
    },
    position: { x: 50, y: 45 },
    nodeShape: 'octagon',
    icon: '💨',
  },
  {
    id: 'F_YUN_2',
    name: '千里奔袭',
    description: '全地形机动：云国骑兵无视地形减速',
    branch: 'faction',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['F_YUN_1', 'N024'],
    factionExclusive: 'yun',
    effects: {
      bonuses: { cavalryAttack: 1.25, speedBonus: 1.35, forestBonus: 1.2 },
    },
    position: { x: 50, y: 65 },
    nodeShape: 'octagon',
    icon: '🐎',
  },
  {
    id: 'F_YUN_3',
    name: '天马行空',
    description: '势力终极：解锁天马骑士，究极骑兵单位',
    branch: 'faction',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['F_YUN_2', 'Y024'],
    factionExclusive: 'yun',
    effects: {
      bonuses: { cavalryAttack: 1.5, cavalryCharge: 1.6, speedBonus: 1.5 },
    },
    position: { x: 50, y: 85 },
    nodeShape: 'octagon',
    icon: '🦄',
    quote: '天马行空，来去如风',
  },
];

export const FACTION_TECHS: Tech[] = [
  ...YAN_TECHS,
  ...HAN_TECHS,
  ...LIN_TECHS,
  ...SHANG_TECHS,
  ...XUAN_TECHS,
  ...TIE_TECHS,
  ...YUN_TECHS,
];

// Export individual faction tech arrays for easier access
export { YAN_TECHS, HAN_TECHS, LIN_TECHS, SHANG_TECHS, XUAN_TECHS, TIE_TECHS, YUN_TECHS };
